import { render, staticRenderFns } from "./luckyBag.vue?vue&type=template&id=208e1542&"
import script from "./luckyBag.vue?vue&type=script&lang=js&"
export * from "./luckyBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports